module.exports = "<p>{{localize 'CORE.FORM.EDITORS.RADIOGROUP.EMPTYRADIOGROUP'}}</p>";